import Layout from "@/components/layout";
import AccessRestricted from "@/components/AccessRestricted";
import AgentRulesController from "@/modules/agents/AgentRulesController";
import { useHasPermission } from "@/store/authStore";
import { Permission } from "@forgepoint/shared";

const BREADCRUMBS = [{ label: "Shop Rules", current: true }];

/**
 * Shop Rules page that displays and manages agent shop rules.
 * Allows users to view and delete rules that can be loaded into agent context.
 * Renders an access denied state when the user lacks the shop rules view permission.
 */
export default function AgentRules() {
  const canView = useHasPermission(Permission.SHOPRULES_VIEW);

  if (!canView) {
    return <AccessRestricted breadcrumbs={BREADCRUMBS} />;
  }

  return (
    <Layout breadcrumbs={BREADCRUMBS}>
      <AgentRulesController />
    </Layout>
  );
}
